import { getData, postDataExternal } from 'src/api/transcodingHttp.service';
import { getEnvVars } from 'src/config';
import { handleApiError, handleApiSuccess } from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

export const TranscodingManagerActionTypes = {
  GET_TOBE_TRANSCODED_JOBS: '[API] : Get list of to be transcoded jobs.',
  GET_TOBE_RE_TRANSCODED_JOBS: '[API] : Get list of to be re transcoded jobs.',
  GET_CANCELLED_JOBS: '[API] : Get list of cancelled jobs.',
  GET_ERRORED_JOBS: '[API] : Get list of errored jobs.',
  GET_SUBMITTED_JOBS: '[API] : Get list of submitted jobs.',
  GET_RUNNING_JOBS: '[API] : Get list of running jobs.',
  GET_FINISHED_JOBS: '[API] : Get list of finished jobs.',

  GET_ADDITIONAL_CANCELLED_JOBS: '[API] : Get additional cancelled jobs for pagination.',
  GET_ADDITIONAL_ERRORED_JOBS: '[API] : Get additional errored jobs for pagination.',
  GET_ADDITIONAL_SUBMITTED_JOBS: '[API] : Get additional submitted jobs for pagination.',
  GET_ADDITIONAL_RUNNING_JOBS: '[API] : Get additional running jobs for pagination.',
  GET_ADDITIONAL_FINISHED_JOBS: '[API] : Get additional finished jobs for pagination.',

  UPDATE_TRANSCODING_SUCCESS: '[UI] : Update Is Transcoding Success',

  CANCEL_JOBS: '[API] : Cancel jobs.',
};

/*
  Plain Actions
*/

export function GetToBeReTranscodedJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_TOBE_RE_TRANSCODED_JOBS,
    payload,
  };
}

export function GetCancelledJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_CANCELLED_JOBS,
    payload,
  };
}

export function GetAdditionalCancelledJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_ADDITIONAL_CANCELLED_JOBS,
    payload,
  };
}

export function GetErroredJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_ERRORED_JOBS,
    payload,
  };
}

export function GetAdditionalErroredJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_ADDITIONAL_ERRORED_JOBS,
    payload,
  };
}

export function CancelJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.CANCEL_JOBS,
    payload,
  };
}

export function GetTobeTranscodedJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_TOBE_TRANSCODED_JOBS,
    payload,
  };
}

export function GetSubmittedJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_SUBMITTED_JOBS,
    payload,
  };
}

export function GetAdditionalSubmittedJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_ADDITIONAL_SUBMITTED_JOBS,
    payload,
  };
}

export function GetRunningJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_RUNNING_JOBS,
    payload,
  };
}

export function GetAdditionalRunningJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_ADDITIONAL_RUNNING_JOBS,
    payload,
  };
}

export function GetFinishedJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_FINISHED_JOBS,
    payload,
  };
}

export function GetAdditionalFinishedJobsSuccessAction(payload) {
  return {
    type: TranscodingManagerActionTypes.GET_ADDITIONAL_FINISHED_JOBS,
    payload,
  };
}

export function UpdateIsTranscodingSuccess(payload) {
  return {
    type: TranscodingManagerActionTypes.UPDATE_TRANSCODING_SUCCESS,
    payload,
  };
}

/*
  Async Actions
*/

export function GetTobeReTranscodedJobsAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(GetToBeReTranscodedJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function CancelJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, headers);
      dispatch(CancelJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetTobeTranscodedJobsAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(GetTobeTranscodedJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetCancelledJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, {
        ...headers,
        // eslint-disable-next-line no-undef
        environment: getEnvVars().transcodingEnvironment,
      });
      dispatch(GetCancelledJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetAdditionalCancelledJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, {
        ...headers,
        // eslint-disable-next-line no-undef
        environment: getEnvVars().transcodingEnvironment,
      });
      dispatch(GetAdditionalCancelledJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetErroredJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, {
        ...headers,
        // eslint-disable-next-line no-undef
        environment: getEnvVars().transcodingEnvironment,
      });
      dispatch(GetErroredJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetAdditionalErroredJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, {
        ...headers,
        // eslint-disable-next-line no-undef
        environment: getEnvVars().transcodingEnvironment,
      });
      dispatch(GetAdditionalErroredJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetSubmittedJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, {
        ...headers,
        // eslint-disable-next-line no-undef
        environment: getEnvVars().transcodingEnvironment,
      });
      dispatch(GetSubmittedJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetAdditionalSubmittedJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, {
        ...headers,
        // eslint-disable-next-line no-undef
        environment: getEnvVars().transcodingEnvironment,
      });
      dispatch(GetAdditionalSubmittedJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetRunningJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, {
        ...headers,
        // eslint-disable-next-line no-undef
        environment: getEnvVars().transcodingEnvironment,
      });
      dispatch(GetRunningJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetAdditionalRunningJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, {
        ...headers,
        // eslint-disable-next-line no-undef
        environment: getEnvVars().transcodingEnvironment,
      });
      dispatch(GetAdditionalRunningJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetFinishedJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, {
        ...headers,
        // eslint-disable-next-line no-undef
        environment: getEnvVars().transcodingEnvironment,
      });
      dispatch(GetFinishedJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetAdditionalFinishedJobsAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postDataExternal(url, body, {
        ...headers,
        // eslint-disable-next-line no-undef
        environment: getEnvVars().transcodingEnvironment,
      });
      dispatch(GetAdditionalFinishedJobsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
